export default __webpack_public_path__ + "static/media/ac_swro.bf1fa2a2.bmp";